<template>
  <div>
    <v-row>
      <v-col cols="12">
        <formulario-info-panel
          :key="formularioData.id"
          :formulario-data="formularioData"
          @refresh-data="getData"
          @secao-criada="getData"
        >
        </formulario-info-panel>
      </v-col>
    </v-row>

    <v-card
      flat
      class="my-4 d-flex justify-center"
    >
      <v-card-title>Seções do Formulário</v-card-title>
    </v-card>

    <v-expansion-panels>
      <secao-campos-cliente></secao-campos-cliente>

      <secao-personalizada
        v-for="s in secoesPersonalizadas"
        :key="s.id"
        :secao-data="s"
        @secao-removida="getData"
      >
      </secao-personalizada>

      <secao-mensagens></secao-mensagens>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mdiPlusCircle } from '@mdi/js'
import { ref, onMounted } from '@vue/composition-api'
import FormularioInfoPanel from '@/views/formulario/FormularioInfoPanel.vue'
import SecaoPersonalizada from '@/views/formulario/secoes/SecaoPersonalizada.vue'
import SecaoMensagens from '@/views/formulario/secoes/secao-mensagens/SecaoMensagens.vue'
import SecaoCamposCliente from '@/views/formulario/secoes/secao-campos-cliente/SecaoCamposCliente.vue'
import router from '@/router'
import TiposDeSecoesEnum from '@/models/entities/formulario/secao/TiposDeSecoesEnum'
import useFormularioViewStore from '@/store/formulario-view'
import FormularioService from '@/services/modules/FormularioService'

export default {
  components: {
    FormularioInfoPanel,
    SecaoPersonalizada,
    SecaoMensagens,
    SecaoCamposCliente,
  },

  setup() {
    const isConfigurarSecaoDialogOpen = ref(false)

    const formularioData = ref({})
    const secoesPersonalizadas = ref([])

    const store = useFormularioViewStore()

    async function getData() {
      formularioData.value = await FormularioService.getFormularioById(router.currentRoute.params.id)

      secoesPersonalizadas.value = formularioData.value.secoes.filter(s => s.idSecaoTipo === TiposDeSecoesEnum.Personalizada)

      store.setFormularioBot(formularioData.value.formularioBot)
    }

    onMounted(async () => { await getData() })

    return {
      isConfigurarSecaoDialogOpen,
      formularioData,
      secoesPersonalizadas,
      getData,
      icons: {
        mdiPlusCircle,
      },
    }
  },
}
</script>
